var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M823.524 322.89c0-178.24-142.585-322.89-318.671-322.89s-318.671 144.651-318.671 322.89c0 61.531 17.037 120.576 48.67 171.583l272.226 526.804h2.050l269.494-533.139c28.949-48.468 44.902-105.702 44.902-165.248z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M682.321 321.634c0 95.649-77.745 173.186-173.649 173.186s-173.648-77.538-173.648-173.186 77.745-173.187 173.648-173.187c95.905 0 173.649 77.538 173.649 173.187z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M632.709 321.634c0 68.322-55.533 123.706-124.037 123.706s-124.035-55.384-124.035-123.706c0-68.319 55.531-123.704 124.035-123.704s124.037 55.385 124.037 123.704z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.88ffc85fa0c4b7f1067806d40552b0e7.svg";
export { ForwardRef as ReactComponent };